import { Icon } from '@iconify/react';
import { getAppTypeByKey } from 'app/components/common/apps/apps-service';
import styled from 'styled-components';

interface AppTypeProps {
  type: string;
}

const StyledIcon = styled(Icon)`
  width: 18px;
  height: 18px;
`;

export const AppType = ({ type }: AppTypeProps) => {
  const appType = getAppTypeByKey(type);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 0px'
      }}
    >
      <StyledIcon icon={appType.icon} color={appType.color} />
      <span style={{ fontSize: '14px', color: '#1A1919' }}>{appType.name}</span>
    </div>
  );
};
